import {
	Box,
	ListSubheader,
	MenuItem,
	Select,
	SelectChangeEvent,
	Typography,
} from "@mui/material";
import { styled } from "@mui/material/styles";
import GroupChattingIcon from "components/icon/GroupChattingIcon";
import WattingToChatIcon from "components/icon/WattingToChatIcon";
import AlertMessage from "components/utils/AlertMessage";
import CircularProgressBox from "components/utils/CircularProgressBox";
import { useGetLocations } from "lib/api/locations";
import { useGetMachineStatus } from "lib/api/status";
import { useState } from "react";

const TextName = styled(Typography)({
	marginTop: "1rem",
	fontWeight: 400,
	fontSize: "1.2rem",
});

const TextTitle = styled(Typography)({
	marginTop: "1rem",
	fontWeight: 400,
	fontSize: "1.4rem",
});

const TextDescription = styled(Typography)({
	marginTop: "0",
	fontWeight: 700,
	fontSize: "2rem",
});

const WashingMachineStatus = () => {
	const [modalAlert, setModalAlert] = useState<{
		isOpen: boolean;
		message: string | string[];
		type: "error" | "success" | "info" | "warning";
	}>({
		isOpen: false,
		message: "",
		type: "warning",
	});
	const { data: locations } = useGetLocations();
	const handleGetMachineStatus = useGetMachineStatus((err) => {
		setModalAlert({
			isOpen: true,
			message: err?.response?.data?.error?.message || "エラー",
			type: "error",
		});
	});
	const washingMachineData = handleGetMachineStatus.data?.data;

	const BoxImageStatus = styled(Box)(() => ({
		width: "100%",
		height: "200px",
		margin: "15px auto 0",
		backgroundImage: `url(${washingMachineData?.image?.value})`,
		backgroundSize: "contain",
		backgroundRepeat: "no-repeat",
		backgroundPosition: "center",
	}));

	const handleChange = (event: SelectChangeEvent<string>) => {
		handleGetMachineStatus.mutate(event.target.value)
	};

	return (
		<Box>
			<Select
				fullWidth
				value={handleGetMachineStatus?.variables ?? ""}
				onChange={handleChange}
				placeholder="洗浄機を選択する"
			>
				{locations?.flatMap((location) => [
					<ListSubheader key={"location-" + location.id}>
						{location.name}
					</ListSubheader>,
					...(location.sections?.map((section) => (
						<MenuItem
							value={section.washingMachine.code ?? ""}
							key={"section-" + section.id}
							sx={{ paddingLeft: 4 }}
						>
							{section.name}
						</MenuItem>
					)) || []),
				])}
			</Select>
			{handleGetMachineStatus.isPending ? (
				<Box marginTop={2}>
					<CircularProgressBox />
				</Box>
			) : washingMachineData?.id && (
				<>
					<TextName align="left">{washingMachineData?.washingMachineName}</TextName>

					<TextTitle>洗浄機の利用状況</TextTitle>
					<TextDescription>{washingMachineData?.statusI18n}</TextDescription>
					<TextTitle>ただいまの状況</TextTitle>
					<Box display="flex" alignItems="center" justifyContent="center">
						<TextDescription>{washingMachineData?.situation}</TextDescription>
						{washingMachineData?.situation === "憩い待ち" ? (
							<WattingToChatIcon width={48.54} height={48.54} />
						) : washingMachineData?.situation === "大勢憩い中" ? (
							<GroupChattingIcon width={48.54} height={48.54} />
						) : (
							<></>
						)}
					</Box>
					<BoxImageStatus />
				</>
			)}
			<AlertMessage
				open={modalAlert.isOpen}
				setOpen={(open: boolean) => setModalAlert({ isOpen: open, message: '', type: 'warning' })}
				severity={modalAlert.type}
				message={modalAlert.message}
			/>
		</Box>
	);
};

export default WashingMachineStatus;
